// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__EzCs0","header":"ClearentDisclaimer_header__2WYKk","inner":"ClearentDisclaimer_inner__11lK-"};